var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("titles.extra-info")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { style: { paddingBottom: "0" } },
        [
          _c("w-tabs", {
            staticClass: "light",
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          }),
        ],
        1
      ),
      _c("w-scroll-view", { attrs: { tag: "w-card-content" } }, [
        _vm.activeTab == 0
          ? _c(
              "div",
              [
                _vm.clientStats.Open > 0 || _vm.clientStats.Expired > 0
                  ? _c(
                      "w-row",
                      [
                        _c("w-col", [
                          _c("div", { staticClass: "invoice-info" }, [
                            _vm.clientStats.Open > 0
                              ? _c("span", { staticClass: "info-warning" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$ct(
                                        _vm.clientStats.Open > 1
                                          ? "open-documents"
                                          : "open-document",
                                        {
                                          count: _vm.clientStats.Open,
                                          amount:
                                            _vm.clientStats.TotalOpen.toFixed(
                                              2
                                            ),
                                        }
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm.clientStats.Expired > 0
                              ? _c("span", { staticClass: "info-danger" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$ct(
                                        _vm.clientStats.Expired > 1
                                          ? "expired-documents"
                                          : "expired-document",
                                        {
                                          count: _vm.clientStats.Expired,
                                          amount:
                                            _vm.clientStats.TotalExpired.toFixed(
                                              2
                                            ),
                                        }
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.contact.Info
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          [
                            _vm.showEditor
                              ? _c("w-editor", {
                                  attrs: {
                                    height: "400",
                                    value: _vm.contactInfoDisplay,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onInput($event)
                                    },
                                    "cursor-position": function ($event) {
                                      return _vm.$emit(
                                        "cursor-position",
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _c("w-textarea-autogrow", {
                                  attrs: {
                                    value: _vm.contactInfoDisplay,
                                    fancy: "",
                                    "min-height": 150,
                                    label: _vm.$ct("labels.extra-info"),
                                  },
                                  on: { input: _vm.updateContactInfo },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.activeTab == 1
          ? _c(
              "div",
              [
                _vm.isAllowed
                  ? _c("app-extra-fields", {
                      attrs: {
                        value: _vm.contact.ExtraFields,
                        "name-settings": _vm.settings,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.update()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }